import {Controller} from "stimulus";
import Rails from "rails-ujs";

export class ApplicationController extends Controller {
    getControllerByIdentifier(identifier) {
        return this.application.controllers.find(controller => {
            return controller.context.identifier === identifier;
        });
    }
    railsDelete({ url, data, dataType, withCredentials }) {
        return new Promise((resolve, reject) => {
            Rails.ajax({
                type: "DELETE",
                data,
                url,
                withCredentials,
                dataType,
                success: data => {
                    resolve(data);
                },
                error: (_jqXHR, _textStatus, errorThrown) => {
                    reject(errorThrown);
                }
            });
        });
    }



    railsGet({ url, data, dataType, withCredentials, crossDomain= false }) {
        return new Promise((resolve, reject) => {
            Rails.ajax({
                type: "GET",
                data,
                url,
                withCredentials,
                dataType,
                crossDomain,
                success: data => {
                    resolve(data);
                },
                error: (_jqXHR, _textStatus, errorThrown) => {
                    reject(errorThrown);
                }
            });
        });
    }

    railsPost({ url, data }) {
        return new Promise((resolve, reject) => {
            Rails.ajax({
                type: "POST",
                url,
                data: JSON.stringify(data),
                contentType: "application/json",
                success: data => resolve(data),
                error: (_jqXHR, _textStatus, errorThrown) => reject(errorThrown)
            });
        });
    }

    railsPatch({ url, data, dataType = 'json' }) {
        return new Promise((resolve, reject) => {
            Rails.ajax({
                type: "PATCH",
                url,
                data: JSON.stringify(data),
                dataType,
                contentType: "application/json",
                success: data => resolve(data),
                error: (_jqXHR, _textStatus, errorThrown) => reject(errorThrown)
            });
        });
    }

    _debounce = (func, delay) => (...args) => {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
        this.timerId = setTimeout(() => {
            func(...args);
            this.timerId = null;
        }, delay);
    };
}
